<template>
  <div>
    <section id="section-collection-viewer" :style="textStyle">
      <div class="back-button">
        <div @click="$router.back()" v-if="global.prevRouteExists">
          <img :src="require('@/assets/images/icons/close.svg')" />
        </div>
        <router-link
          :to="`${global.mainPage.presentationId ? `/presentation/${this.global.mainPage.presentationId}` : ''}/`"
          v-else
        >
          <img :src="require('@/assets/images/icons/close.svg')" />
        </router-link>
      </div>

      <div v-if="collection">
        <CollectionViewerPlayer :collectionItem="collection" />
        <div class="collection-container" id="collection-container">
          <lottie
            class="scroll-indicator scroll-indicator-absolute"
            id="scroll-indicator-collection"
            :options="scrollDefaultOptions"
            :height="36"
            :width="36"
            v-on:animCreated="handleAnimation"
          />
          <div class="collection-content">
            <h2>{{collection.title}}</h2>
            <p v-html="collection.description"></p>
            <div
              class="collection-viewer-row"
              v-for="(row, index) in collection.collection_info_repeater"
              :key="'cv' + index"
            >
              <span v-if="row.label" class="collection-viewer-label">{{row.label.trim()}}&nbsp;</span>

              <a
                v-if="row.value && detectLink(row.value.trim())"
                class="collection-viewer-value"
                :href="buildLink(row.value)"
                target="_blank"
              >{{row.value.trim()}}</a>
              <span class="collection-viewer-value" v-else-if="row.value">{{row.value.trim()}}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import { mapState } from "vuex";
import CollectionViewerPlayer from "@/components/sections/MainPage/CollectionViewerPlayer";
import Footer from "@/components/global/Footer";
import { TweenLite } from "gsap/dist/gsap";
import * as ScrollMagic from "scrollmagic";
import { TimelineLite } from "gsap/all";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import * as scrollAnimationData from "@/assets/anim/scroll.json";
import Lottie from "vue-lottie";

ScrollMagicPluginGsap(ScrollMagic, TimelineLite);

import { gsap, CSSPlugin } from "gsap/all";
gsap.registerPlugin(CSSPlugin);
export default {
  name: "CollectionViewer",
  components: {
    CollectionViewerPlayer,
    Footer,
    Lottie
  },
  data() {
    return {
      collection: null,
      initFinished: false,
      initInterval: null,
      tween: new TimelineLite({ paused: true }),
      scene: new ScrollMagic.Scene({
        triggerElement: this.$refs.sectionHome,
        triggerHook: "onLeave",
        duration: 100,
        offset: 0
      }),
      controller: new ScrollMagic.Controller(),
      scrollDefaultOptions: { animationData: scrollAnimationData.default },
      anim: null
    };
  },
  computed: {
    ...mapState(["global"]),
    secondaryFontColor(){
      return `--green_font: ${this.$store.getters.themeSettings.secondary_font_color};`;
    },
    mainFontColor(){
      return `--main_font: ${this.$store.getters.themeSettings.main_font_color};`;
    },
    textStyle() {
      return `${this.secondaryFontColor} ${this.mainFontColor}`;
    },
  },

  // beforeDestroy() {
  //   document.getElementById("main-page").style.display = "block";
  // },
  mounted() {
    // setTimeout(function() {
    //   document.getElementById("main-page").style.display = "block";
    // }, 500);

    // window.scrollTo(0, 0);

    let collection = this.global.collections.find(
      collection =>
        collection.id.toString() === this.$route.params.id.toString()
    );
    if (collection && collection.acf) {
      this.collection = collection.acf;
      document.title = collection.acf.title;
    } else {
      window.location = "/";
    }

    let that = this;

    let debouncedAdjustIndicator = this.debounce(function() {
      that.adjustIndicatorPosition();
    }, 250);

    this.initInterval = setInterval(this.initDocMethods, 250);

    window.addEventListener("resize", debouncedAdjustIndicator);
  },
  methods: {
    detectLink(string) {
      return (
        string.indexOf("www") > -1 ||
        string.indexOf(".com") > -1 ||
        string.indexOf("http") > -1 ||
        string.indexOf('.ca') > -1
      );
    },
    buildLink(string){
      if(string.indexOf('http') == -1){
        let linkString = string;
        if(string.indexOf('www.') == -1){
            linkString = 'www.' + string;
        }
        return 'http://' + linkString;
      }
      return string;
    },
    addScrollMagicEffects() {
      let scrollIndicator = document.getElementById(
        "scroll-indicator-collection"
      );
      scrollIndicator.style.transform = "translate(-50%,0px)";
      this.scene
        .setTween(
          this.tween.to(
            scrollIndicator,
            1,
            { translateY: `-=${100}`, opacity: `-=1` },
            0
          )
        )
        .addTo(this.controller);
    },
    destroyParalax() {
      this.controller.destroy();
      this.scene.destroy();
      this.tween.kill();
      this.controller = null;
      this.scene = null;
      this.tween = null;
    },
    initDocMethods() {
      if (this.initFinished) {
        clearInterval(this.initInterval);
        this.initInterval = null;
        this.initFinished = true;
        return;
      }

      let videoCollectionWrapper = document.getElementById(
        "videoCollectionWrapper"
      );
      let scrollIndicator = document.getElementById(
        "scroll-indicator-collection"
      );
      if (!videoCollectionWrapper || !scrollIndicator) {
        return;
      }

      this.adjustIndicatorPosition();
      this.addScrollMagicEffects();
      this.initFinished = true;
      clearInterval(this.initInterval);
      this.initInterval = null;
    },

    debounce(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this,
          args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    adjustIndicatorPosition() {
      let videoCollectionWrapper = document.getElementById(
        "videoCollectionWrapper"
      );
      let scrollIndicator = document.getElementById(
        "scroll-indicator-collection"
      );
      if (!videoCollectionWrapper || !scrollIndicator) return;

      if (videoCollectionWrapper.offsetHeight >= window.innerHeight) {
        scrollIndicator.classList.remove("scroll-indicator-absolute");
        scrollIndicator.classList.add("scroll-indicator-fixed");
      } else {
        scrollIndicator.classList.remove("scroll-indicator-fixed");
        scrollIndicator.classList.add("scroll-indicator-absolute");
      }
    },
    handleAnimation: function(anim) {
      this.anim = anim;
    },

    stopAnimation: function() {
      this.anim.stop();
    },

    playAnimation: function() {
      this.anim.play();
    },

    pauseAnimation: function() {
      this.anim.pause();
    }
  }
};
</script>

<style lang="scss" scoped>
#section-collection-viewer {
  position: relative;

  .scroll-indicator-absolute {
    position: absolute;
    top: 10px;
  }
  .scroll-indicator-fixed {
    position: fixed;
    bottom: 50px;
    height: 30px;
  }
  .scroll-indicator {
    left: 50%;
    transform: translateX(-50%);
    min-height: 30px;
    width: 1px;
    z-index: 999;
    svg {
      height: 60px;
    }
  }
  .back-button {
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 999;
    cursor: pointer;
    img {
      height: 24px;
      width: 24px;
    }
  }
  .collection-container {
    background: $new_black;
    display: flex;
    justify-content: center;
    z-index: 99;
    position: relative;
    .collection-content {
      max-width: 100%;
      width: 680px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      padding: 200px 16px;
      h2 {
        font-family: "AvenirLTStd-Black";
        font-size: 36px;
        color: var(--main_font);
        text-transform: uppercase;
        margin-bottom: 4px;
        letter-spacing: 2px;
      }
      p {
        margin: 0;
        margin-bottom: 24px;
        font-family: "AvenirLTStd-Roman";
        font-size: 16px;
        color: var(--main_font);
        letter-spacing: 0;
        text-align: left;
        line-height: 24px;
      }
      .collection-viewer-row {
        .collection-viewer-label {
          opacity: 0.5;
          font-family: "AvenirLTStd-Black";
          font-size: 12px;
          color: var(--main_font);
          text-align: left;
          line-height: 16px;
          text-transform: uppercase;
          opacity: 0.5;
        }
        .collection-viewer-value {
          font-family: "AvenirLTStd-Black";
          font-size: 12px;
          color: var(--main_font);
          text-align: left;
          line-height: 16px;
          text-transform: uppercase;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
// .slide-enter {
//   right: 100vw;
// }
// .slide-enter-to {
//   right: 0;
// }
// .slide-enter-active {
//   transition: .5s; /* MISSING RULE */
// }

// .slide-leave {
//   right: 0;
// }
// .slide-leave-to {
//   right: -100vw;
// }
// .slide-leave-active {
//   transition: .5s; /* MISSING RULE */
// }
.slide-enter-active {
  // animation: slideInRight 0.75s;
  // position: fixed;
  // top: 0;
  // bottom: 0;
  // left: 0;
  // right: 0;
  z-index: 999;
  // transition: all 1s;
  // transform: translate3d(0,0,0);
}
// .slide-enter{
//   transform: translate3d(100%,0,0)!important;
// }
.slide-leave-active {
  animation: slideInRight 0.5s reverse;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
}
@keyframes slideInRight {
  0% {
    transform: translate3d(100%, 0, 0);
  }

  100% {
    transform: none;
  }
}
</style>